import { render, staticRenderFns } from "./Left.vue?vue&type=template&id=32312cf3&"
import script from "./Left.vue?vue&type=script&lang=js&"
export * from "./Left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports